import { apiSlice } from "../../app/api/apiSlice";

const QUERY_URL = "/notifications";

export const notificationsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query({
      query: () => QUERY_URL,
      providesTags: (result, error, arg) =>
        result
          ? [...result.map(({ _id }) => ({ type: "Notification", id: _id })), "Notification"]
          : ["Notification"],
    }),
    getUnreadCount: builder.query({
      query: () => `${QUERY_URL}/unread-count`,
      providesTags: ["Notification"],
    }),
    markAsRead: builder.mutation({
      query: (id) => ({
        url: `${QUERY_URL}/mark-read/${id}`,
        method: "PATCH",
      }),
      invalidatesTags: ["Notification"],
    }),
    markAllAsRead: builder.mutation({
      query: () => ({
        url: `${QUERY_URL}/mark-all-read`,
        method: "PATCH",
      }),
      invalidatesTags: ["Notification"],
    }),
    deleteNotification: builder.mutation({
      query: (id) => ({
        url: `${QUERY_URL}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Notification"],
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useGetUnreadCountQuery,
  useMarkAsReadMutation,
  useMarkAllAsReadMutation,
  useDeleteNotificationMutation,
} = notificationsApiSlice;
